import {
  createStyles,
  Dialog,
  DialogContent,
  DialogTitle,
  Theme,
  WithStyles,
  withStyles,
  Divider,
  Button,
  DialogActions,
  Card,
  CardHeader,
  Fab,
  IconButton,
  Typography,
} from "@material-ui/core";
import * as React from "react";
import TableComponent from "../components/TableComponent";
import { USERS_COLUMNS } from "../constants/tableColumns";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AddingUsersDialog from "./AddUsersDialog";
import { EventEmitter } from "../events/EventEmitter";
import { AuthenticationService } from "../services/AuthenticationService";
import { SNACKBAR_TYPE } from "../components/SnackBarComponent";
import GenericDialog from "./GenericDialog";
import { isEmpty, getMomentDate } from "../constants/constants";
import { AppContext, AuthConsumer } from "../routes/AuthContext";
import HasPermission from "../auth/HasPermission";
import HasMutablePermission from "../auth/HasMutablePermission";
import { EmployeeService } from "../services/EmployeeService";
import LicenseIcon from "@material-ui/icons/Payment";
import ListItemDialog from "./ListItemDialog";
import { ActionedService } from "../services/ActionedService";
import LoadingComponents from "../components/LoadingComponents";
export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_INPUT: "DIALOG_INPUT",
  DIALOG_ACTION: "DIALOG_ACTION",
  DIALOG_ERROR: "DIALOG_ERROR",
};
export const MODE_TYPE = {
  ADD: "ADD",
  EDIT: "EDIT",
};
const styles = (theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 345,
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    margin: {
      margin: theme.spacing(1),
    },
  });
interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  mode: any;
  companyData?: any;
  handleClose: any;
  handleOnSubmit: any;
}
class ManageCompanyUsersDialog extends React.Component<Props> {
  state = {
    showPassword: false,
    sameAsAbove: false,
    hasError: false,
    data: [],
    openAddUsersDialog: false,
    openConfirmationDialog: false,
    openEmployeeLoginDetailsDialog: false,
    editData: {},
    selectedRow: { fullName: "" },
    recentlyAddedUser: {
      fullName: "",
      employeeNumber: "",
      password: "",
      role: "",
      email: "",
    },
    deleteAll: false,
    actionedInspectionRowSelected: {},
    showConfirmationDialog: false,
    actionedInspectionDeletionObj: { _id: "", inspection: { name: "" } },
    showActionedInspectionsDialog: false,
    actionedInspections: [],
    editedUser: {
      fullName: "",
      employeeNumber: "",
      password: "",
      role: "",
      email: "",
    },
    isLoading: false,
  };
  handleClose = () => {
    this.setState({
      openAddUsersDialog: false,
      openEmployeeLoginDetailsDialog: false,
      openConfirmationDialog: false,
      showActionedInspectionsDialog: false,
      selectedRow: {},
      editData: {},
    });
  };
  handleOpenAddUsersDialog = () => {
    this.setState({ openAddUsersDialog: true, editData: {} });
  };

  componentDidMount = () => {
    this.getUsersByCompanyId();
  };

  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (prevProps.companyData !== this.props.companyData) {
      this.getUsersByCompanyId();
    }
  };

  handleOnDeleteClicked = (item: any) => {
    this.setState({
      showConfirmationDialog: true,
      actionedInspectionDeletionObj: item,
    });
  };
  createUniqueIdentifier = (row: any, index: any) => {
    return `${row._id}`;
  };
  createData = (row: any, accessRules: any) => {
    let contextState = this.context;
    let user = contextState && contextState.user ? contextState.user : null;
    return {
      fullName: row.fullName,
      email: row.email,
      employeeNumber: row.employeeNumber,
      actionedInspections:
        user &&
        HasMutablePermission({
          role: user.role,
          data: user.role,
          accessRules: accessRules,
          perform: "actionedInspection:view",
        })
          ? {
              title: "Actioned Inspections",
              action: this.handleActionedInspections,
            }
          : null,
      phone: row.phone,
      role: row.role,
    };
  };

  getUsersByCompanyId = () => {
    const { companyData } = this.props;
    let authenticationService: AuthenticationService =
      new AuthenticationService();
    this.setState({
      isLoading: true,
    });
    authenticationService.getUsersByCompanyId(companyData._id).then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp && resp.success && resp.users) {
        this.setState({
          data: resp.users,
        });
      } else if (resp.error) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      } else {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.ERROR,
          show: true,
          message: resp.error,
        });
      }
    });
  };

  renderEmployeeLoginDetailsDialog = () => {
    let username = this.state.recentlyAddedUser.employeeNumber
      ? this.state.recentlyAddedUser.employeeNumber
      : this.state.recentlyAddedUser.email;
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={`Login Details for: ${this.state.recentlyAddedUser.fullName}`}
        messages={[
          `Username (Employee Number): ${
            username ? username : this.state.recentlyAddedUser.fullName
          } `,
          `Password: ${this.state.recentlyAddedUser.password}`,
        ]}
        rightButtonName={"OK"}
        open={this.state.openEmployeeLoginDetailsDialog}
        onCancel={() => this.handleClose()}
        onOk={() => this.handleClose()}
        handleClose={() => this.handleClose()}
      />
    );
  };

  handleActionedInspectionConfirmedDelete = () => {
    let deletingObject = this.state.actionedInspectionDeletionObj;
    if (!deletingObject) {
      return;
    }
    let resp = this.state.actionedInspections.filter((item: any) => {
      return item._id === deletingObject._id;
    });
    if (resp.length > 0) {
      let item: any = resp[0];
      let actionedService: ActionedService = new ActionedService();
      this.setState({
        isLoading: true,
      });
      actionedService
        .deleteActionedInspection(item.companyId, item._id)
        .then((resp) => {
          this.setState({
            isLoading: false,
          });
          if (resp && resp.success) {
            this.setState(
              {
                showConfirmationDialog: false,
              },
              async () => {
                await this.getActionedInspectionByCompany(
                  this.state.actionedInspectionRowSelected
                );
              }
            );
          } else if (resp.error) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          }
        });
    }
  };

  handleActionedInspectionConfirmedDeleteAll = () => {
    let row: any = this.state.actionedInspectionRowSelected;
    let actionedService: ActionedService = new ActionedService();
    this.setState({
      isLoading: true,
    });
    actionedService
      .deleteAllActionedInspection(row.companyId, row._id)
      .then((resp) => {
        this.setState({
          isLoading: false,
        });
        if (resp && resp.success) {
          this.setState(
            {
              showActionedInspectionsDialog: false,
            },
            async () => {
              await this.getActionedInspectionByCompany(
                this.state.actionedInspectionRowSelected
              );
            }
          );
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: "Oops something happened",
          });
        }
      });
  };

  handleOnDeleteAllClicked = () => {
    this.setState(
      {
        deleteAll: true,
      },
      () => {
        this.handleClose();
        this.handleActionedInspectionConfirmedDeleteAll();
      }
    );
  };

  handleActionedInspections = (row: any) => {
    this.setState(
      {
        deleteAll: false,
      },
      async () => {
        await this.getActionedInspectionByCompany(row);
      }
    );
  };

  renderActionedInspectionDeleteConfirmationDialog = () => {
    let deletingObject = this.state.actionedInspectionDeletionObj;
    if (!deletingObject) {
      return;
    }
    let contentMessage = {
      title: deletingObject.inspection.name,
      message: "Are you sure you want to delete this Actioned Inspection?",
    };
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={contentMessage.title}
        message={contentMessage.message}
        leftButtonName={"Cancel"}
        rightButtonName={"YES"}
        open={this.state.showConfirmationDialog}
        onCancel={() => this.handleClose()}
        onOk={() => this.handleActionedInspectionConfirmedDelete()}
        handleClose={() => this.handleClose()}
      />
    );
  };

  renderActionedInspectionsDialog = () => {
    let mData: any = [];
    this.state.actionedInspections.map((item: any) => {
      let completionDate = getMomentDate(item.assign.completionDate);
      let mItem = {
        icon: <LicenseIcon />,
        option: `${item.inspection.name}`,
        subtitle: `${
          item.assign.assignedTo.fullName
        } / Completion Date : ${completionDate.toString()}`,
        action: {
          type: "delete",
          renderIconAction: this.renderDeleteAction(item),
        },
      };
      mData.push(mItem);
      return null;
    });
    return (
      <ListItemDialog
        open={this.state.showActionedInspectionsDialog}
        dialogTitle={"Actioned Inspections"}
        data={mData}
        renderDialog={this.renderActionedInspectionDeleteConfirmationDialog()}
        tickAll={true}
        handleOnDeleteAllClicked={this.handleOnDeleteAllClicked}
        onClose={this.handleClose}
      />
    );
  };

  renderDeleteAction = (item: any) => {
    let { classes } = this.props;
    return (
      <IconButton
        aria-label="delete"
        className={classes.margin}
        size="small"
        onClick={() => this.handleOnDeleteClicked(item)}
      >
        <DeleteIcon />
      </IconButton>
    );
  };

  getActionedInspectionByCompany = async (row: any) => {
    let companyId = row.companyId;
    let employeeId = row._id;
    let employeeService: EmployeeService = new EmployeeService();
    this.setState({
      isLoading: true,
    });
    let resp = await employeeService.getActionedInspectionsByCompany(
      companyId,
      employeeId
    );
    this.setState({
      isLoading: false,
    });
    if (resp && resp.success && resp.actioned) {
      this.setState(
        {
          actionedInspections: resp.actioned,
          showActionedInspectionsDialog: this.state.deleteAll ? false : true,
          actionedInspectionRowSelected: row,
        },
        () => {
          let actionedRow: any = this.state.actionedInspectionRowSelected;
          actionedRow.actionedCount = this.state.actionedInspections.length;
          this.setState({
            actionedInspectionRowSelected: actionedRow,
          });
        }
      );
    } else if (resp.error) {
      EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
        type: SNACKBAR_TYPE.ERROR,
        show: true,
        message: resp.error,
      });
    } else {
      EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
        type: SNACKBAR_TYPE.ERROR,
        show: true,
        message: resp.error,
      });
    }
  };

  handleOnEditSubmit = (values: any) => {
    const { companyData } = this.props;
    this.setState({
      isLoading: true,
    });
    let authenticationService: AuthenticationService =
      new AuthenticationService();
    let userModel = values;
    userModel.companyId = companyData._id;
    authenticationService.editUser(userModel).then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp.success && resp.success === true) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "Edited Successfully",
        });
        this.setState(
          {
            editedUser: userModel,
            openAddUsersDialog: false,
            editData: {},
          },
          () => {
            this.getUsersByCompanyId();
          }
        );
      } else {
        if (resp.message && resp.message.errors) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.message.message,
          });
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: "Oops something wrong happened",
          });
        }
      }
    });
  };

  handleOnSubmit = (values: any) => {
    const { companyData } = this.props;
    if (values.dashboard) {
      values.role = "DASHBOARD";
    }
    this.setState({ isLoading: true });
    let authenticationService: AuthenticationService =
      new AuthenticationService();
    let userModel = values;
    userModel.companyId = companyData._id;
    authenticationService.addUser(userModel).then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp.success && resp.success === true) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "User added Successfully",
        });
        this.setState(
          {
            openAddUsersDialog: false,
            openEmployeeLoginDetailsDialog: true,
            recentlyAddedUser: resp.user,
          },
          () => {
            this.getUsersByCompanyId();
          }
        );
      } else {
        if (resp.message && resp.message.errors) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.message.message,
          });
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: "Oops something wrong happened",
          });
        }
      }
    });
  };

  executeDeleteOnEmployeee = (row: any) => {
    const { companyData } = this.props;
    let authenticationService: AuthenticationService =
      new AuthenticationService();
    let userModel = row;
    userModel.companyId = companyData._id;
    this.setState({
      isLoading: true,
    });
    authenticationService.deleteUser(userModel).then((resp) => {
      this.setState({
        isLoading: false,
      });
      if (resp.success && resp.success === true) {
        EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
          type: SNACKBAR_TYPE.SUCCESS,
          show: true,
          message: "Deleted Successfully",
        });
        this.setState(
          {
            openAddUsersDialog: false,
            openConfirmationDialog: false,
            selectedRow: {},
          },
          () => {
            this.getUsersByCompanyId();
          }
        );
      } else {
        if (resp.message && resp.message.errors) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.message.message,
          });
        } else if (resp.error) {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: resp.error,
          });
        } else {
          EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
            type: SNACKBAR_TYPE.ERROR,
            show: true,
            message: "Oops something wrong happened",
          });
        }
      }
    });
  };

  renderAddUsersDialog = () => {
    return (
      <AddingUsersDialog
        title={"Add User"}
        open={this.state.openAddUsersDialog}
        isAdmin={false}
        handleClose={this.handleClose}
        editData={this.state.editData}
        handleOnSubmit={
          this.state.editData && !isEmpty(this.state.editData)
            ? this.handleOnEditSubmit
            : this.handleOnSubmit
        }
      />
    );
  };
  onEditRow = (row: any) => {
    this.setState({
      editData: row,
      openAddUsersDialog: true,
    });
  };
  onViewRow = (row: any) => {};
  deleteAllSelectedCompanyUsers = (selectedList: any) => {
    const { companyData } = this.props;
    let authenticationService: AuthenticationService =
      new AuthenticationService();
    this.setState({
      isLoading: true,
    });
    authenticationService
      .deleteAllSelectedUsers(selectedList, companyData._id)
      .then((resp) => {
        this.setState({
          isLoading: false,
        });
        if (resp.success && resp.success === true) {
          if (resp.deleted) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.SUCCESS,
              show: true,
              message: "Deleted Successfully",
            });
          } else {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.SUCCESS,
              show: true,
              message: "Deleted Successfully,partial",
            });
          }
          this.setState(
            {
              openAddUsersDialog: false,
              openConfirmationDialog: false,
              selectedRow: {},
            },
            () => {
              this.getUsersByCompanyId();
            }
          );
        } else {
          if (resp.message && resp.message.errors) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.message.message,
            });
          } else if (resp.error) {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: resp.error,
            });
          } else {
            EventEmitter.dispatch(EventEmitter.events.SEND_SNACK_MESSAGE, {
              type: SNACKBAR_TYPE.ERROR,
              show: true,
              message: "Oops something wrong happened",
            });
          }
        }
      });
  };
  onDeleteRow = (row: any) => {
    this.setState({
      selectedRow: row,
      openConfirmationDialog: true,
    });
  };
  handleConfirmedDelete = () => {
    this.executeDeleteOnEmployeee(this.state.selectedRow);
  };
  renderDeleteConfirmationDialog = () => {
    if (!this.state.selectedRow || !this.state.selectedRow.fullName) {
      return;
    }
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={`Deleting ${this.state.selectedRow.fullName}`}
        message={"Are you sure want to delete this user"}
        leftButtonName={"Cancel"}
        rightButtonName={"YES"}
        open={this.state.openConfirmationDialog}
        onCancel={() => this.handleClose()}
        onOk={() => this.handleConfirmedDelete()}
        handleClose={() => this.handleClose()}
      />
    );
  };

  dataActions = (tabType: any, user: any, accessRules: any) => {
    return [
      {
        icon: <EditIcon fontSize="small" />,
        name: tabType,
        action: this.onEditRow,
        visible: HasMutablePermission({
          role: user.role,
          accessRules: accessRules,
          perform: "company-users:edit",
          data: user.role,
        }),
      },
      {
        icon: <DeleteIcon fontSize="small" />,
        name: tabType,
        action: this.onDeleteRow,
        visible: HasMutablePermission({
          role: user.role,
          accessRules: accessRules,
          perform: "company-users:delete",
          data: user.role,
        }),
      },
    ];
  };
  render() {
    const { classes, title, open, handleClose } = this.props;
    return (
      <React.Fragment>
        <LoadingComponents isLoading={this.state.isLoading} />
        <AuthConsumer>
          {({ user, accessRules }) => (
            <Dialog
              open={open}
              keepMounted={true}
              onClose={() => handleClose()}
              maxWidth={"lg"}
              fullWidth={true}
            >
              <DialogTitle id="alert-dialog-slide-title">
                <Card elevation={0} style={{ width: "100%" }}>
                  <CardHeader
                    action={
                      <HasPermission
                        role={user.role}
                        accessRules={accessRules}
                        perform="company-users:create"
                        data={user.role}
                        yes={() => (
                          <Fab
                            variant="extended"
                            onClick={() => this.handleOpenAddUsersDialog()}
                          >
                            <AddIcon className={classes.extendedIcon} />
                            {"NEW USER"}
                          </Fab>
                        )}
                        no={() => <div></div>}
                      />
                    }
                    subheader={
                      <Typography
                        variant="caption"
                        display="block"
                        gutterBottom
                      >
                        Logout and Login again after updating the LoggedIn User.
                      </Typography>
                    }
                    title={title}
                  />
                </Card>
              </DialogTitle>
              <Divider />
              <DialogContent>
                <TableComponent
                  tableName={"Manage Users"}
                  columns={USERS_COLUMNS}
                  data={this.state.data}
                  company={this.props.companyData}
                  uniqueIdentifier={this.createUniqueIdentifier}
                  deleteAllSelected={this.deleteAllSelectedCompanyUsers}
                  createData={this.createData}
                  deleteAllAction={"company-users:deleteAll"}
                  actions={this.dataActions(
                    "ManageUseersDialog",
                    user,
                    accessRules
                  )}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    this.getUsersByCompanyId();
                    handleClose(this.state.editedUser);
                  }}
                >
                  {"CONTINUE"}
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </AuthConsumer>
        {this.renderAddUsersDialog()}
        {this.renderEmployeeLoginDetailsDialog()}
        {this.renderDeleteConfirmationDialog()}
        {this.renderActionedInspectionsDialog()}
      </React.Fragment>
    );
  }
}
ManageCompanyUsersDialog.contextType = AppContext;
export default withStyles(styles)(ManageCompanyUsersDialog);
